
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.25 3.751a.75.75 0 01.75-.75h6a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75zm-.75 7.5a1.5 1.5 0 011.5-1.5h.188l.562-4.5h4.5l.563 4.5H12a1.5 1.5 0 011.5 1.5h-9zm3.75.75h1.5v2.25h-1.5v-2.25zM6 14.252c0-.277.603-.52 1.5-.65v.653h3v-.652c.897.13 1.5.372 1.5.65 0 .414-1.343.75-3 .75s-3-.336-3-.75z","fill":"url(#prefix__paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"prefix__paint0_linear","x1":"9","y1":"3.001","x2":"9","y2":"15.001","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#E1A200"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#ECC042"}})])])])
          )
        }
      }
    